import React from "react"
import { Layout, Icon } from "antd"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import { getMedia } from "../../api/common"

import Menu from "../../components/Menu"
import NavigationMenu from "../../components/Navigation"

const { Header, Sider } = Layout

class PrivateLayout extends React.Component {
  state = {
    collapsed: false,
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }

  render() {
    const { isLogin, app } = this.props
    if (!isLogin) {
      return <Redirect to={"/"} />
    }
    return (
      <Layout>
        <Sider
          trigger={null}
          collapsible
          collapsed={this.state.collapsed}
          width={280}
        >
          <div className="logo">
            <div className="logo-wrapper">
              <img src={getMedia(app.application_icon)} alt="logo" />
            </div>
            <div className="title">Web Partner</div>
            <div className="detail">{app.name}</div>
          </div>
          <Menu />
        </Sider>
        <Layout>
          <Header style={{ paddingLeft: 24, paddingRight: 24 }}>
            <Icon
              className="trigger"
              type={this.state.collapsed ? "menu-unfold" : "menu-fold"}
              onClick={this.toggle}
            />
            <NavigationMenu />
          </Header>
          {this.props.children}
        </Layout>
      </Layout>
    )
  }
}

export default connect((state) => ({
  isLogin: state.auth.accessToken != null,
  app: state.auth.app,
}))(PrivateLayout)



// WEBPACK FOOTER //
// ./src/components/Layout/index.js